import type { JSX } from "react";
import { Outlet } from "react-router";

/** Full-bleed wrapper so the graph canvas can paint edge-to-edge under AppShell. */
export default function GraphLayout(): JSX.Element {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col">
      <div className="relative min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
